/**
 * Created by FLI on 2015-01-16.
 */

var navmenu = {
	init: function()
	{
		//Display the title tags as a sub-text
		//I'm doing this with javascript because I want to
		//be able to edit the sub-texts in the wp admin menu settings
		//and by default the only available field is "Title Attribute"
		var $root = jQuery("nav.menu-container");
		if( ! $root.length )
		{
			return false;
		}
		var $hrefs = $root.find('a');
		if( ! $hrefs.length )
		{
			return false;
		}
		jQuery($hrefs).each(function(i,v)
		{
			//Override navigation on contact form link
			if( jQuery(v).attr('href').indexOf('/contact') > -1 || jQuery(v).attr('href').indexOf('/kontakt') > -1 )
			{
				jQuery(v).attr('href', 'javascript:void(0);').attr('onclick','navmenu.contact();');
			}
		});

		var $menu = $root.find("ul.menu");

		//center menu
		/*
		var width = $menu.width();
		$menu.css("margin-left", (parseInt(width/2) * -1) +"px" );
		*/

		//assign "last" to last element
		$menu.children().last().addClass("last");

		//handle menu button position when scrolling
		jQuery(window).bind("scroll", function(){
			navmenu.menuButtonPositioner();
		});

		jQuery('body').on({
			'touchmove': function(e) {
				navmenu.menuButtonPositioner();
			}
		});

		//Bind navigate function to all a hrefs in menu
		jQuery($menu).find('a').bind( 'click', function() { navmenu.navigate( this ); });

		//Clean up
		$root.hide().removeClass("behind");

		return true;
	},
	menuButtonPositioner: function()
	{
		var body_y = jQuery('body').scrollTop();
		var html_y = jQuery('html').scrollTop();
		var top_y = Math.max( body_y, html_y );

		jQuery("#menu-button-open, #menu-button-close, #contact-button-close").css("top",Math.max( 20, 60 - top_y )+"px");
	},
	opening: false,
	opened: false,
	open: function()
	{
		if( navmenu.opening || navmenu.opened ) {
			return;
		}
		navmenu.opening = true;
		jQuery(".page-viewport").toggleClass( "blur" );
		jQuery("nav.menu-container").show().switchClass( "transparent", "opaque", 400 );
		jQuery("#menu-button-close").fadeIn(400);
		jQuery("#menu-button-open").fadeOut(400);

		//Scroll menu into view
		jQuery("html, body").animate({ scrollTop: "0px", easing: 'easeOutQuint' });

		//Handle accidental double-taps
		setTimeout(function(){ navmenu.opening = false; navmenu.opened = true; },400);
	},
	closing: false,
	close: function()
	{
		if( navmenu.closing || ! navmenu.opened ) {
			return;
		}
		navmenu.closing = true;
		jQuery(".page-viewport").toggleClass( "blur" );
		jQuery("nav.menu-container").switchClass( "opaque", "transparent", 400, "swing", function(){ jQuery("nav.menu-container").hide(); } );
		jQuery("#menu-button-close").fadeOut(400);
		jQuery("#menu-button-open").fadeIn(400);

		//Handle accidental double-taps
		setTimeout(function(){ navmenu.closing = false; navmenu.opened = false; },400);
	},
	navigate: function( target )
	{
		navmenu.close();
		//TODO: Loading anim, stuff
	},
	hide: function()
	{
		jQuery("#menu-button-open").fadeOut(400);
	},
	show: function()
	{
		jQuery("#menu-button-open").fadeIn(400);
	},
	contact: function()
	{
		var scope = angular.element(jQuery(".contact-container")).scope();
		if( scope )
		{
			scope.$apply(function()
			{
				scope.open();
			});
		}
	}
}

jQuery( document ).ready(function(){
	navmenu.init();
	jQuery(window).on('ngPageLoadSuccess', function(){
		setTimeout( function() {
			if( ! navmenu.init() ) { //First attempt after ½ second
				setTimeout( function() {
					navmenu.init(); //Second attempt after 5½ seconds
				}, 5000 );
			}
		}, 500 );
	});
});